import React, {useEffect, useState} from "react";
import SimpleTable from "../../../common/tables/SimpleTable";
import {useDispatch, useSelector} from "react-redux";
import CapServicePopover from "./CapServicePopover";
import {deleteCapServiceGroup, loadCapServiceGroups} from "../../../../actions/capServiceGroupActions";
import ActionPopover from "../../../common/popovers/ActionPopover";
import {getRusDateHourString} from "../../../../utils/dateUtils";
import {ASC, DESC} from "../../../../utils/constants";
import {sort} from "../../../../utils/sortUtils";


export default function CapServiceTable({}) {

    const dispatch = useDispatch();
    const capServices = useSelector(state => state.capServiceGroupReducer.capServiceGroups);

    const [renderedData, setRenderedData] = useState(null);
    const [sortingData, setSortingData] = useState({
        sortableColumn: "creationTime",
        sortableDirection: DESC
    });

    useEffect(() => {
        dispatch(loadCapServiceGroups());
    }, []);

    useEffect(() => {
        if (!capServices || capServices.length === 0) {
            return;
        }
        const {sortableColumn, sortableDirection} = sortingData;
        const directionNumb = !sortableDirection
            ? 0
            : sortableDirection === ASC
                ? 1
                : -1;
        const renderedData = sort(capServices, sortableColumn, directionNumb);
        setRenderedData(renderedData);

    }, [capServices, sortingData.sortableColumn, sortingData.sortableDirection, ])

    const changeSortData = (fieldName, direction) => {
        setSortingData({
            sortableColumn: fieldName,
            sortableDirection: direction
        })
    };

    const renderCapServicePopover = (button, capService) => {
        return <CapServicePopover button={button} capService={capService}/>
    };

    const deleteGroup = (id) => {
        dispatch(deleteCapServiceGroup(id, () => dispatch(loadCapServiceGroups())))
    }


    const tableColumns = () => {
        return [
            {
                name: "CAP сервис",
                key: "name",
                getBodyCellValue: item => item["name"],
                headerCellStyle: {minWidth: "150px"},
                bodyCellStyle: {textAlign: "left"},
            },
            {
                name: "Подписочные сервисы",
                key: "serviceIds",
                getBodyCellValue: item => item["serviceIds"]?.sort().join(", ") || "",
                headerCellStyle: {minWidth: "150px", textAlign: "left"},
                bodyCellStyle: {textAlign: "left"},
            },
            {
                name: "Дата добавления",
                key: "creationTime",
                getBodyCellValue: item => item["creationTime"] ? getRusDateHourString(new Date(item["creationTime"])) : "",
                headerCellStyle: {minWidth: "100px", textAlign: "left"},
                bodyCellStyle: {textAlign: "left"},
            },
            {
                name: "Дата обновления",
                key: "updateTime",
                getBodyCellValue: item => item["updateTime"] ? getRusDateHourString(new Date(item["updateTime"])) : "",
                headerCellStyle: {minWidth: "100px", textAlign: "left"},
                bodyCellStyle: {textAlign: "left"},
            },
            {
                name: renderCapServicePopover(<i className="ti ti-plus" style={{cursor: "pointer", fontSize: "18px"}}
                                                 title="Добавить"/>),
                key: "actions",
                getBodyCellValue: (capService) => <div style={{display: "flex"}}>
                    {renderCapServicePopover(<i className="ti ti-pencil td-save" title="Редактировать"/>, capService)}
                    <ActionPopover
                        button={<i className="ti ti-trash td-save"/>}
                        tooltip="Удалить"
                        popoverLocation='right'
                        label={<div style={{textAlign: "center"}}>
                            <div>Вместе с CAP сервисом будут безвозвратно удалены все связанные с ним капы.</div>
                            <div>Продолжить?</div>
                    </div>}
                        handleSubmit={() => deleteGroup(capService.id)}/>
                </div>,
                headerCellStyle: {textAlign: "left"},
                bodyCellStyle: {textAlign: "left", minWidth: "105px", width: "105px", paddingRight: "15px"},
                isSortingDisabled: true,
            },
        ]
    };

    return (
        <div>
            <div className="responsive-block statistic_table_wrapper" id="capServiceTable" onScroll={() => {}}>
                <SimpleTable
                    tableClassName="table table-bordered nowrap statistic_table sticky-header sticky-action sticky-footer userselecttext"
                    columns={tableColumns()}
                    data={renderedData} bodyRowKey="name"
                    isSortable
                    sortableDirection={sortingData?.sortableDirection}
                    sortableColumn={sortingData?.sortableColumn}
                    onSort={changeSortData}
                />
            </div>
        </div>
    )
};